import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        progress: { type: Number, required: true },
    },
});
